/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveBoxOpenDocsIcon20Solid = forwardRef('ArchiveBoxOpenDocsIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.5.5a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5h-7Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 4.75C4.25 3.784 5.034 3 6 3h8c.966 0 1.75.784 1.75 1.75V7h.5a.75.75 0 0 1 .75.75v7.75a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 15.5V7.75A.75.75 0 0 1 3.75 7h.5V4.75Zm10 0V7h-8.5V4.75A.25.25 0 0 1 6 4.5h8a.25.25 0 0 1 .25.25ZM8 10a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H8Z" })));
});
